export default __webpack_public_path__ + "static/media/Facilities-CACS-5.945bf96c.jpg";